module.exports = __webpack_public_path__ + "img/boa-6-modified.036ee00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/boa-6-modified.png
// module id = 1316
// module chunks = 1